import { lookupVariable } from '../../variables/lookupVariable.js';
import { getTimeRange } from './getTimeRange.js';
import { getVariables, getData, getLayout, getDataLayers, interpolate, hasVariableDependencyInLoadingState, findObject, getAncestor } from './sceneGraph.js';

const sceneGraph = {
  getVariables,
  getData,
  getTimeRange,
  getLayout,
  getDataLayers,
  interpolate,
  lookupVariable,
  hasVariableDependencyInLoadingState,
  findObject,
  getAncestor
};

export { sceneGraph };
//# sourceMappingURL=index.js.map
